import { Route, useLocation } from 'react-router-dom';
import type { ElementType } from 'react';
import { useEffect } from 'react';
import { useAuth } from '@eti/authentication';
import { usePageViewDataLayerEvent } from '../../data-layer/dataLayer';
import { useGA4PageViewEvent } from '../../data-layer/ecommerce/custom-hooks/useGA4PageViewEvent';

interface ContactUsRouteProps {
  component: ElementType;
  setIsMenuVisible: (pathname: { type: string }) => void;
  shouldSkipDataLayerEvent?: boolean;
  exact?: boolean;
  path: string;
  contactUsOrderListComponent: ElementType;
}

const ContactUsRoute = ({
  component: Component,
  contactUsOrderListComponent: ContactUsOrderListComponent,
  setIsMenuVisible,
  shouldSkipDataLayerEvent,
  ...rest
}: ContactUsRouteProps) => {
  const location = useLocation();
  const { user } = useAuth();

  usePageViewDataLayerEvent(undefined, shouldSkipDataLayerEvent);
  useGA4PageViewEvent({
    responsive_url: '/rf/contact-us',
    page_type: 'Contact Us',
    page_type_detailed: user ? 'Order List' : 'General',
  });
  useEffect(() => {
    setIsMenuVisible({ type: location.pathname });
  }, [setIsMenuVisible, location.pathname]);

  return (
    <Route
      {...rest}
      render={() => {
        if (user) {
          return <ContactUsOrderListComponent />;
        }
        return <Component />;
      }}
    />
  );
};

export default ContactUsRoute;
